/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  AvailablePlans,
  CurrentSubscription,
  FeatureCheck,
  LimitCheck,
  UpdateWLSubscriptionBillingEmail200,
  WLUpdateBillingEmailRequest
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Returns the current entity subscription with plan details and usage stats. Requires entity context.
 * @summary Get current subscription
 */
export type getCurrentWLSubscriptionResponse200 = {
  data: CurrentSubscription
  status: 200
}

export type getCurrentWLSubscriptionResponseSuccess = (getCurrentWLSubscriptionResponse200) & {
  headers: Headers;
};
;

export type getCurrentWLSubscriptionResponse = (getCurrentWLSubscriptionResponseSuccess)

export const getGetCurrentWLSubscriptionUrl = () => {


  

  return `/white-label-subscriptions`
}

export const getCurrentWLSubscription = async ( options?: RequestInit): Promise<getCurrentWLSubscriptionResponse> => {
  
  return customFetch<getCurrentWLSubscriptionResponse>(getGetCurrentWLSubscriptionUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Returns available subscription plans for the current white-label.
 * @summary Get available plans
 */
export type getWLSubscriptionPlansResponse200 = {
  data: AvailablePlans
  status: 200
}

export type getWLSubscriptionPlansResponseSuccess = (getWLSubscriptionPlansResponse200) & {
  headers: Headers;
};
;

export type getWLSubscriptionPlansResponse = (getWLSubscriptionPlansResponseSuccess)

export const getGetWLSubscriptionPlansUrl = () => {


  

  return `/white-label-subscriptions/plans`
}

export const getWLSubscriptionPlans = async ( options?: RequestInit): Promise<getWLSubscriptionPlansResponse> => {
  
  return customFetch<getWLSubscriptionPlansResponse>(getGetWLSubscriptionPlansUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Checks if a specific feature is available on the current subscription plan.
 * @summary Check feature access
 */
export type checkWLFeatureResponse200 = {
  data: FeatureCheck
  status: 200
}

export type checkWLFeatureResponseSuccess = (checkWLFeatureResponse200) & {
  headers: Headers;
};
;

export type checkWLFeatureResponse = (checkWLFeatureResponseSuccess)

export const getCheckWLFeatureUrl = (feature: string,) => {


  

  return `/white-label-subscriptions/check-feature/${feature}`
}

export const checkWLFeature = async (feature: string, options?: RequestInit): Promise<checkWLFeatureResponse> => {
  
  return customFetch<checkWLFeatureResponse>(getCheckWLFeatureUrl(feature),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Checks if the current usage allows creating more of a resource type.
 * @summary Check resource limit
 */
export type checkWLLimitResponse200 = {
  data: LimitCheck
  status: 200
}

export type checkWLLimitResponseSuccess = (checkWLLimitResponse200) & {
  headers: Headers;
};
;

export type checkWLLimitResponse = (checkWLLimitResponseSuccess)

export const getCheckWLLimitUrl = (resource: string,) => {


  

  return `/white-label-subscriptions/check-limit/${resource}`
}

export const checkWLLimit = async (resource: string, options?: RequestInit): Promise<checkWLLimitResponse> => {
  
  return customFetch<checkWLLimitResponse>(getCheckWLLimitUrl(resource),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Updates the billing email used for white-label subscription notifications and invoices.
 * @summary Update billing email
 */
export type updateWLSubscriptionBillingEmailResponse200 = {
  data: UpdateWLSubscriptionBillingEmail200
  status: 200
}

export type updateWLSubscriptionBillingEmailResponseSuccess = (updateWLSubscriptionBillingEmailResponse200) & {
  headers: Headers;
};
;

export type updateWLSubscriptionBillingEmailResponse = (updateWLSubscriptionBillingEmailResponseSuccess)

export const getUpdateWLSubscriptionBillingEmailUrl = () => {


  

  return `/white-label-subscriptions/billing-email`
}

export const updateWLSubscriptionBillingEmail = async (wLUpdateBillingEmailRequest: WLUpdateBillingEmailRequest, options?: RequestInit): Promise<updateWLSubscriptionBillingEmailResponse> => {
  
  return customFetch<updateWLSubscriptionBillingEmailResponse>(getUpdateWLSubscriptionBillingEmailUrl(),
  {      
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      wLUpdateBillingEmailRequest,)
  }
);}
  

